module.exports = __webpack_public_path__ + "media/student_v2/assets/images/student-alert-checkbox-indeterminate-67f375e1f6131e5380576389fb946870.svg";